<template>
<div class="">
    <div class=" backgroundcolor2 borderadius12">
        <div class="card-body text-center pt-5 pb-5">
            <div class="p-5 d-flex flex-column text-center">
                <img src="../assets/no_video.svg" class="img-fluid no-video pl-5 pr-5 pb-4 mx-auto" alt="novideo">
                <span class="proximanova-thin fontsize24 black60">To access these screens you should create your profile</span>
                <button class="postingVideo proximanova btn btn-default mt-4 p-1 mx-auto" @click="NavToCreateProfile">Create Profile</button>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import router from '../router.js'
export default {
    data(){
        return{

        }
    },
    methods : {
        NavToCreateProfile : function(){
            router.push({
                name : 'createprofile'
            })
        }
    }
}
</script>
<style scoped>
.postingVideo {
  cursor: pointer; 
  text-align: center;
  border-radius: 16px;
  width: 140px;
  background-color: black;
  color: white !important;
  transition : ease-out 0.3s;
	POSITION : relative;
	z-index : 1
}
.postingVideo::before {
	transition : 0.5s all ease;
	position : absolute;
	top : 0;
	left : 30%;
	right : 30%;
	bottom : 0;
	opacity : 0;
	content : "";
  border-radius: 16px;
	background-color :  rgba(255,255,255,.3);
}
.postingVideo:hover:before {
	transition : 0.5s all ease;
	left : 0;
	right : 0;
	opacity : 1;
	z-index : -1
}
/* @media screen and (max-width: 1020px) and (min-width: 767px) {
  .main-card {
    padding-left: 5%;
    padding-right: 5%;
  }
} */
</style>